import { useUnit } from 'effector-react'

import {
  $clientAttachmentHistory,
  $totalCountOfClientAttachmentHistory,
  getClientAttachmentHistory,
  clientAttachmentHistoryMounted,
  $errorClientAttachmentHistoryRequest,
} from './model'
import { ClientAttachmentHistoryRequest } from './types'

export const useClientAttachmentHistoryWidget = () => {
  const onChangeClientAttachmentHistoryList = ({
    limit,
    page,
  }: ClientAttachmentHistoryRequest) => {
    clientAttachmentHistoryMounted({
      limit,
      page,
    })
  }
  const clientAttachmentHistory = useUnit($clientAttachmentHistory)
  const totalCountOfClientAttachmentHistory = useUnit(
    $totalCountOfClientAttachmentHistory,
  )
  const errorClientAttachmentHistoryRequest = useUnit(
    $errorClientAttachmentHistoryRequest,
  )

  const loading = useUnit(getClientAttachmentHistory.pending)

  return {
    clientAttachmentHistory,
    loading,
    totalCountOfClientAttachmentHistory,
    onChangeClientAttachmentHistoryList,
    errorClientAttachmentHistoryRequest,
  }
}
